var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinearGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 0C9.50368 0 9 0.50368 9 1.125V10.875C9 11.4963 9.50368 12 10.125 12H10.875C11.4963 12 12 11.4963 12 10.875V1.125C12 0.50368 11.4963 0 10.875 0H10.125Z",
    fill: "#5AA552"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3C5.00368 3 4.5 3.50368 4.5 4.125V10.875C4.5 11.4963 5.00368 12 5.625 12H6.375C6.99632 12 7.5 11.4963 7.5 10.875V4.125C7.5 3.50368 6.99632 3 6.375 3H5.625Z",
    fill: "#5AA552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 6C0.50368 6 0 6.50368 0 7.125V10.875C0 11.4963 0.50368 12 1.125 12H1.875C2.49632 12 3 11.4963 3 10.875V7.125C3 6.50368 2.49632 6 1.875 6H1.125Z",
    fill: "#5AA552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearGraph);
export default __webpack_public_path__ + "static/media/linear-graph.8cc559a3c6f12462667cfb7762962962.svg";
export { ForwardRef as ReactComponent };